module.exports = "/_next/static/images/eeb01350a46d55677715e23bb243dca1-hero-mobile-10.jpg.webp";